// src/components/material/AppIconButton.js
// IconButton com Tooltip obrigatório (acessibilidade).
//
// API:
//   tooltip — string required (label do botão para leitor de tela)
//   icon    — ReactNode
//   onClick, disabled, color
//   size    — 'default' (44) | 'small' (36) — herda do theme MuiIconButton

import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

export default function AppIconButton({
  tooltip,
  icon,
  onClick,
  disabled,
  size = 'default',
  color = 'default',
  sx,
  ...rest
}) {
  if (!tooltip) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[AppIconButton] tooltip prop is required for accessibility')
    }
  }

  const button = (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      size={size === 'small' ? 'small' : 'large'}
      color={color}
      aria-label={tooltip}
      sx={sx}
      {...rest}
    >
      {icon}
    </IconButton>
  )

  if (!tooltip) return button

  return (
    <Tooltip title={tooltip} arrow placement="top">
      {/* span wrap permite tooltip mesmo com disabled */}
      <span>{button}</span>
    </Tooltip>
  )
}
